import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCoins, FaFire, FaGem, FaCrown, FaGift } from 'react-icons/fa';
import { liveGiftAPI } from '../utils/api';
import { toast } from 'sonner';

const GIFTS = [
  { type: 'pointphoria', icon: FaCoins, label: 'PP', amounts: [10, 50, 100], color: 'text-amber-500', bg: 'bg-amber-50' },
  { type: 'fire', icon: FaFire, label: 'Fire', amounts: [50, 200, 500], color: 'text-orange-500', bg: 'bg-orange-50' },
  { type: 'diamond', icon: FaGem, label: 'Diamond', amounts: [200, 500, 1000], color: 'text-cyan-500', bg: 'bg-cyan-50' },
  { type: 'crown', icon: FaCrown, label: 'Crown', amounts: [500, 1000, 5000], color: 'text-purple-500', bg: 'bg-purple-50' },
];

const LiveGiftPanel = ({ streamId, onGiftSent }) => {
  const [showPanel, setShowPanel] = useState(false);
  const [sending, setSending] = useState(false);

  const handleGift = async (type, amount) => {
    setSending(true);
    try {
      const res = await liveGiftAPI.sendGift(streamId, amount, type);
      toast.success(res.data.message);
      onGiftSent?.(type, amount);
      setShowPanel(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to send gift');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="relative">
      <button onClick={() => setShowPanel(v => !v)} data-testid="live-gift-btn" className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-gradient-to-r from-amber-500 to-orange-500 text-white font-semibold text-sm hover:shadow-lg transition-all">
        <FaGift size={14} /><span>Gift</span>
      </button>

      <AnimatePresence>
        {showPanel && (
          <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 8 }} className="absolute bottom-full right-0 mb-2 bg-white rounded-2xl shadow-2xl border border-gray-200 p-4 w-72 z-40" data-testid="gift-panel">
            <p className="text-sm font-bold text-gray-900 mb-3">Send a Gift</p>
            <div className="space-y-3">
              {GIFTS.map(g => (
                <div key={g.type} className="flex items-center gap-2">
                  <div className={`w-8 h-8 rounded-full ${g.bg} flex items-center justify-center flex-shrink-0`}>
                    <g.icon className={g.color} size={14} />
                  </div>
                  <span className="text-xs font-semibold text-gray-700 w-14">{g.label}</span>
                  <div className="flex gap-1 flex-1">
                    {g.amounts.map(amt => (
                      <button key={amt} onClick={() => handleGift(g.type, amt)} disabled={sending} data-testid={`gift-${g.type}-${amt}`} className={`flex-1 py-1.5 rounded-lg text-xs font-bold ${g.bg} ${g.color} hover:opacity-80 transition-all disabled:opacity-40`}>
                        {amt}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LiveGiftPanel;
